import React from "react";
import PropTypes from "prop-types";

const Imagenes = ({
  images,
  fixedHeight = null,
  fixedWidth = null,
  backgroundColor = "#fff",
}) => {
  return (
    <div style={galleryContainerStyle}>
      {images.map((src, index) => (
        <div key={index} style={{ ...imageWrapperStyle, backgroundColor }}>
          <img
            src={src}
            alt={`Gallery item ${index + 1}`}
            style={{
              ...imageStyle,
              ...(fixedHeight && { height: fixedHeight, width: "auto" }),
              ...(fixedWidth && { width: fixedWidth, height: "auto" }),
            }}
            loading="lazy"
          />
        </div>
      ))}
    </div>
  );
};

// Define los estilos para el contenedor de la galería
const galleryContainerStyle = {
  display: "grid",
  gap: "5px", // Reducir el espacio entre imágenes
  padding: "5px",
  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
  justifyContent: "center",
  alignItems: "center",
};

// Estilos del contenedor de cada imagen
const imageWrapperStyle = {
  overflow: "hidden",
  borderRadius: "8px",
  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

// Estilos de las imágenes para adaptarse y mantener proporciones
const imageStyle = {
  objectFit: "contain", // Ajuste para mostrar imagen completa sin recortes
  maxWidth: "100%",
  maxHeight: "100%",
  transition: "transform 0.3s ease",
};

Imagenes.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  fixedHeight: PropTypes.string, // Altura fija opcional (e.g., "300px")
  fixedWidth: PropTypes.string, // Ancho fijo opcional (e.g., "300px")
  backgroundColor: PropTypes.string, // Color de fondo para las imágenes con relleno
};

export default Imagenes;
